import { cx } from '@lastbrand/web-ui-styled-system/css'
import React from 'react'

import { OptionProp } from '@src/quince-site-pdp/src/atoms/optionSelector/OptionSelector.constant'

import { OptionContainerDS } from './option-container-ds'
import { textLabelClass } from './text-option-ds.styles'

type TextOptionDSProps = {
  value: string
  displayName?: string
  disabled?: boolean
  onChange?: (value: string) => void
  lastChanceSizes?: (string | undefined)[]
} & Pick<OptionProp, 'isSelected' | 'selectionSetId' | 'className'>

// SIZE / TEXT option: native radio + Panda label showing `displayName || value`.
// The OOS "last chance" strikethrough is applied by `OptionContainerDS` via `lastChanceSizes`.
export const TextOptionDS = ({
  value,
  displayName,
  isSelected,
  selectionSetId,
  disabled,
  className,
  onChange,
  lastChanceSizes,
}: TextOptionDSProps) => {
  return (
    <OptionContainerDS
      value={value}
      displayName={displayName}
      selectionSetId={selectionSetId}
      isSelected={isSelected}
      srOnly={false}
      disabled={disabled}
      labelClassName={cx(textLabelClass, className)}
      onChange={onChange}
      lastChanceSizes={lastChanceSizes}
    >
      {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
      <span>{displayName || value}</span>
    </OptionContainerDS>
  )
}

const TextOptionDSWithOptionValue = ({ optionValue, ...props }: OptionProp) => {
  return <TextOptionDS value={optionValue.value} displayName={optionValue.displayName} {...props} />
}

export default TextOptionDSWithOptionValue
